import { useState } from "react";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  SparklesIcon,
  RefreshCwIcon,
} from "lucide-react";

type PromptLibraryProps = {
  activeThreadId?: string | null;
  hasMessages?: boolean;
  loading: boolean;
  onRefresh: () => void;
  onSelectPrompt: (prompt: string) => void;
  suggestions: string[];
};

export function PromptLibrary({
  activeThreadId,
  hasMessages = false,
  loading,
  onRefresh,
  onSelectPrompt,
  suggestions,
}: PromptLibraryProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="border-t border-border">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-4 py-2.5 text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted/50"
      >
        <div className="flex items-center gap-1.5">
          <SparklesIcon className="w-3.5 h-3.5 text-violet-500" />
          <span>Suggested Questions</span>
        </div>
        {isOpen ? (
          <ChevronUpIcon className="w-3.5 h-3.5" />
        ) : (
          <ChevronDownIcon className="w-3.5 h-3.5" />
        )}
      </button>

      {isOpen && (
        <div className="px-3 pb-3 flex flex-wrap gap-1.5">
          {loading && (
            <div className="text-xs text-muted-foreground px-2 py-1">
              Loading fresh questions...
            </div>
          )}

          {!loading && suggestions.length === 0 && (
            <div className="text-xs text-muted-foreground px-2 py-1">
              {!activeThreadId || activeThreadId.startsWith("temp-")
                ? "Start a conversation to see suggestions"
                : !hasMessages
                  ? "Send a message to get personalized suggestions"
                  : "No suggestions available"}
            </div>
          )}

          {suggestions.map((question) => (
            <button
              key={question}
              type="button"
              onClick={() => onSelectPrompt(question)}
              className="text-xs px-3 py-1.5 rounded-full border border-violet-200 bg-violet-50 text-violet-700 hover:bg-violet-100 transition-all text-left leading-snug"
            >
              {question}
            </button>
          ))}

          {suggestions.length > 0 && (
            <button
              type="button"
              onClick={onRefresh}
              className="flex items-center gap-1 text-[10px] text-violet-500 hover:text-violet-600 px-2 py-1"
            >
              <RefreshCwIcon className="w-3 h-3" /> Refresh
            </button>
          )}
        </div>
      )}
    </div>
  );
}
